import PropTypes from 'prop-types';
import React from "react";
import { Button } from "reactstrap";

const NOT_CLICKABLE_STYLE = { cursor: "default" };

const Status = ({ status, title }) => {
  if(status === "Inativo" ) {
    return (
      <Button
        color="danger"
        size="sm"
        style={NOT_CLICKABLE_STYLE}
        tabIndex={-1}
      >
        {title}
      </Button>
      );
  }

  return (
  <Button
    color="info"
    size="sm"
    style={NOT_CLICKABLE_STYLE}
    tabIndex={-1}
  >
    {title}
  </Button>
  );
};

Status.propTypes = {
  status: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Status;


// status pode ser ativo ou inativo
